import React from 'react';
import { ArrowRight, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';
import ContactForm from './ContactForm';

const CTASection = () => {
  return (
    <section id="contact" className="bg-black py-24 lg:py-32 relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-electric-yellow/5 rounded-full blur-3xl" />
      </div>
      
      {/* Animated electric lines */}
      <div className="absolute top-0 left-0 w-full h-px overflow-hidden">
        <div className="w-full h-full bg-gradient-to-r from-transparent via-electric-yellow to-transparent animate-electric-horizontal" />
      </div>
      <div className="absolute bottom-0 left-0 w-full h-px overflow-hidden">
        <div className="w-full h-full bg-gradient-to-r from-transparent via-electric-yellow to-transparent animate-electric-horizontal-reverse" />
      </div>
      
      {/* Electric spark decorations */}
      <div className="absolute top-1/4 left-10 w-1.5 h-1.5 bg-electric-yellow rounded-full animate-ping opacity-40" style={{ animationDuration: '2s' }} />
      <div className="absolute bottom-1/3 right-16 w-1 h-1 bg-electric-yellow rounded-full animate-ping opacity-50" style={{ animationDuration: '2.5s', animationDelay: '0.5s' }} />
      
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-[7.6923%]">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-electric-yellow/10 border border-electric-yellow/30 mb-8">
            <MapPin size={16} className="text-electric-yellow" />
            <span className="text-electric-yellow text-sm font-medium">
              Serving All of Canada
            </span>
          </div>
          
          {/* Headline */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Ready to Power Your<br />
            <span className="text-electric-yellow animate-electric-flicker">Next Project?</span>
          </h2>
          
          <p className="text-xl text-neutral-400 mb-12 max-w-2xl mx-auto">
            From coast to coast, Nexline Electrical delivers premium electrical 
            services for residential and commercial clients across Canada.
          </p>
          
          {/* CTAs with electric glow */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <a
              href="#quote"
              className="group inline-flex items-center justify-center gap-4 bg-electric-yellow text-black px-10 py-5 text-lg font-semibold hover:bg-electric-yellow/10 hover:text-electric-yellow border-2 border-electric-yellow transition-all duration-400 hover:shadow-[0_0_30px_rgba(255,214,0,0.4)]"
            >
              Request a Free Quote
              <ArrowRight 
                size={20} 
                className="transform group-hover:translate-x-1 transition-transform duration-300"
              />
            </a>
            <a
              href={`tel:${companyInfo.phone}`}
              className="group inline-flex items-center justify-center gap-3 bg-white/5 text-white px-10 py-5 text-lg font-semibold hover:bg-white hover:text-black border border-white/20 transition-all duration-400"
            >
              <Phone size={20} />
              {companyInfo.phone}
            </a>
          </div>
          
          {/* Trust line with electric dots */}
          <div className="flex items-center justify-center gap-8 text-neutral-500 text-sm mb-16">
            <span>Licensed</span>
            <div className="w-1 h-1 bg-electric-yellow rounded-full animate-pulse" />
            <span>Insured</span>
            <div className="w-1 h-1 bg-electric-yellow rounded-full animate-pulse" style={{ animationDelay: '0.2s' }} />
            <span>Code Compliant</span>
            <div className="w-1 h-1 bg-electric-yellow rounded-full animate-pulse" style={{ animationDelay: '0.4s' }} />
            <span>Safety First</span>
          </div>
        </div>

        {/* Contact form */}
        <div id="quote" className="mt-4">
          <h3 className="text-2xl font-semibold text-white text-center mb-8">
            Or Send Us Your Project Details
          </h3>
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default CTASection;
